import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */
class HelpPanelSharedService {
    constructor() {
        this.toggle$ = new BehaviorSubject(false);
        this.toggled$ = this.toggle$.asObservable();
        this.featuredArticlesLabel = '';
    }
    toggle(value) {
        this.toggle$.next(value);
    }
    closeHelpPanel() {
        this.toggle$.next(false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HelpPanelSharedService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HelpPanelSharedService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HelpPanelSharedService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { HelpPanelSharedService };
